import React from "react";
import { FormContext } from "./Form";
import type { InputPropsFunc } from "./Form";
export type RendererFunc = (arg0: {
  getInputProps: InputPropsFunc;
}) => React.ReactNode;
type Renderer = {
  children: RendererFunc;
} | {
  render: RendererFunc;
};
type Props = Renderer & {
  name: string;
  placeholder?: any;
};

const getRenderContent = ({
  props
}) => ({
  getInputProps
}) => props.children ? props.children({
  getInputProps: getInputProps && getInputProps(props.name)
}) : props.render({
  getInputProps: getInputProps && getInputProps(props.name)
});

const Field = (props: Props) => <FormContext.Consumer>{getRenderContent({
    props
  })}</FormContext.Consumer>;

export default Field;